export default "__VITE_ASSET__Bfy1cnWS__"